export type SystemChainDirection = "right" | "left" | "down" | null;

export type SystemChainPosition = {
  column: number;
  row: number;
  direction: SystemChainDirection;
};

const MAX_COLUMNS = 4;
const PREFERRED_CARD_WIDTH = 260;
const COLUMN_GAP = 46;

export function getSystemChainColumns(containerWidth: number, stepCount: number) {
  if (stepCount <= 0) return 1;
  const fittingColumns = Math.floor((Math.max(0, containerWidth) + COLUMN_GAP) / (PREFERRED_CARD_WIDTH + COLUMN_GAP));
  return Math.max(1, Math.min(MAX_COLUMNS, stepCount, fittingColumns));
}

export function getSystemChainLayout(stepCount: number, columns: number): SystemChainPosition[] {
  const safeColumns = Math.max(1, Math.min(columns, Math.max(1, stepCount)));
  return Array.from({ length: stepCount }, (_, index) => {
    const rowIndex = Math.floor(index / safeColumns);
    const positionInRow = index % safeColumns;
    const rowRunsRight = rowIndex % 2 === 0;
    const column = rowRunsRight ? positionInRow + 1 : safeColumns - positionInRow;
    const isLast = index === stepCount - 1;
    const isRowEnd = positionInRow === safeColumns - 1;
    const direction: SystemChainDirection = isLast ? null : isRowEnd ? "down" : rowRunsRight ? "right" : "left";
    return { column, row: rowIndex + 1, direction };
  });
}
